import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { dollars } from "utils/money";

const styles = theme => ({
  listKey: {
    color: theme.palette.lightGrey,
    width: '120px',
    fontSize: '14px'
  }
});

class LoanDetails extends React.Component {
  render = () => {
    const { application } = this.props;
    return (
      <div>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Amount" />
            <ListItemText primary={dollars(application.form.amount)} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Term Length" />
            <ListItemText primary={application.form.termLength} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Term Unit" />
            <ListItemText primary={application.form.termUnit} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Frequency" />
            <ListItemText primary={application.form.frequency} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Drawdown Date" />
            <ListItemText primary={moment(application.form.drawdownDate).format('DD/MM/YYYY')} />
          </ListItem>
        </List>
      </div>
    );
  }
}

const styled = withStyles(styles)(LoanDetails)
export default styled;



// WEBPACK FOOTER //
// ./src/components/Applications/LoanDetails.js